import { FaMapMarkerAlt, FaMedal, FaTruck } from 'react-icons/fa'
export const contactData = [{
    icon: <FaMedal />,
    title: "NEPAL’S FULL-FLEDGED ONLINE MUSICAL INSTRUMENTS STORE",
    details: "More than 500 products, 50 brands, 5000 satisfied customers"
},
{
    icon: <FaTruck />,
    title: "FASTEST DELIVERY",
    details: "Fastest Delivery ( Same day delivery in Kathmandu )",
},
{
    icon: <FaMapMarkerAlt />,
    title: "COME VISIT US",
    details: "We are located at Shantinagar-Baneshwor, Kathmandu. Do pay us a visit and check out our products!"
}]
export default contactData